import PropTypes from 'prop-types';
const Card = (props) => {
  const { children, condense, elevation = true } = props;
  return (
    <div
      className={`bg-white ${
        elevation ? 'shadow-card' : ''
      } rounded-xl w-full h-full relative overflow-hidden`}
    >
      <div className={`${condense ? 'p-0' : 'p-8'} h-full`}>{children}</div>
      {/* <button className='px-23'>Generate Quate</button> */}
    </div>
  );
};
Card.propTypes = {
  condense: PropTypes.bool,
  elevation: PropTypes.bool,
};

export default Card;
